// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tvd__card__empty[data-v-f62321b6]{border:2px dashed #ccc;border-radius:6px;padding:20px;margin-bottom:8px;text-align:center;color:#999;min-height:80px;display:flex;align-items:center;justify-content:center}.tvd__card__empty p[data-v-f62321b6]{margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
